export type SiteRoute = {
  /** İç (TR) yol — SeoMeta anahtarı ve TR URL'i */
  path: string;
  labelTr: string;
  labelEn: string;
  /** Navbar dropdown başlığı (varsa) — listede girintili gösterilir */
  parentTr?: string;
};

export type SiteRouteGroup = {
  titleTr: string;
  routes: SiteRoute[];
};

// Web navbar'ındaki link yapısının birebir karşılığı
// (apps/web/src/components/layout/navbar.tsx → navLinks)
export const SITE_ROUTE_GROUPS: SiteRouteGroup[] = [
  {
    titleTr: "Navbar",
    routes: [
      { path: "/", labelTr: "Ana Sayfa", labelEn: "Home" },
      { path: "/hakkimizda", labelTr: "Hakkımızda", labelEn: "About", parentTr: "Kurumsal" },
      { path: "/hakkimizda/tarihce", labelTr: "Tarihçe", labelEn: "History", parentTr: "Kurumsal" },
      {
        path: "/hakkimizda/degerlerimiz",
        labelTr: "Değerlerimiz",
        labelEn: "Our Values",
        parentTr: "Kurumsal",
      },
      {
        path: "/hakkimizda/kalite-politikamiz",
        labelTr: "Kalite Politikamız",
        labelEn: "Quality Policy",
        parentTr: "Kurumsal",
      },
      {
        path: "/hakkimizda/sosyal-sorumluluk",
        labelTr: "Sosyal Sorumluluk",
        labelEn: "Social Responsibility",
        parentTr: "Kurumsal",
      },
      { path: "/markalarimiz", labelTr: "Markalarımız", labelEn: "Brands" },
      {
        path: "/insan-kaynaklari/ik-politikamiz",
        labelTr: "İK Politikamız",
        labelEn: "HR Policy",
        parentTr: "İnsan Kaynakları",
      },
      {
        path: "/insan-kaynaklari/endeks-kariyer",
        labelTr: "Endeks Kariyer",
        labelEn: "Endeks Career",
        parentTr: "İnsan Kaynakları",
      },
      { path: "/blog", labelTr: "Blog", labelEn: "Blog" },
      { path: "/iletisim", labelTr: "İletişim", labelEn: "Contact" },
    ],
  },
  {
    titleTr: "Footer",
    routes: [
      { path: "/kvkk-politikasi", labelTr: "KVKK Politikası", labelEn: "KVKK Policy" },
      { path: "/cerez-politikasi", labelTr: "Çerez Politikası", labelEn: "Cookie Policy" },
      { path: "/gizlilik-politikasi", labelTr: "Gizlilik Politikası", labelEn: "Privacy Policy" },
    ],
  },
  {
    titleTr: "Diğer Sayfalar",
    routes: [
      {
        path: "/is-ortagi-basvurusu",
        labelTr: "İş Ortağı Başvurusu",
        labelEn: "Partner Application",
      },
    ],
  },
];

export const SITE_ROUTES: SiteRoute[] = SITE_ROUTE_GROUPS.flatMap((g) => g.routes);

// EN URL segmentleri ("/en" öneki OLMADAN). Web'deki next-intl `pathnames` eşlemesinin
// (apps/web/src/i18n/pathnames.ts) birebir karşılığı — orası değişirse burayı da güncelle.
// SeoMeta kayıtları TR yolla anahtarlanır; bu eşleme yalnızca önizleme URL'i içindir.
export const EN_PATHS: Record<string, string> = {
  "/": "/",
  "/hakkimizda": "/about",
  "/hakkimizda/tarihce": "/about/history",
  "/hakkimizda/degerlerimiz": "/about/our-values",
  "/hakkimizda/kalite-politikamiz": "/about/quality-policy",
  "/hakkimizda/bilgi-toplumu-hizmetleri": "/about/information-society-services",
  "/hakkimizda/sosyal-sorumluluk": "/about/social-responsibility",
  "/markalarimiz": "/brands",
  "/blog": "/blog",
  "/iletisim": "/contact",
  "/is-ortagi-basvurusu": "/partner-application",
  "/insan-kaynaklari/endeks-kariyer": "/human-resources/careers",
  "/insan-kaynaklari/ik-politikamiz": "/human-resources/hr-policy",
  "/kvkk-politikasi": "/personal-data-protection",
  "/gizlilik-politikasi": "/privacy-policy",
  "/cerez-politikasi": "/cookie-policy",
};

// Detay sayfalarının EN kökleri (slug öncesi)
export const EN_ENTITY_BASES = {
  blog: "/blog",
  brand: "/brands",
  social: "/about/social-responsibility",
} as const;

/** Önizleme için dile göre yol (EN'de İngilizce segmentler; "/en" öneki GooglePreview'da) */
export function previewPathFor(path: string, lang: string): string {
  return lang === "en" ? (EN_PATHS[path] ?? path) : path;
}
